import React, { useMemo } from 'react';
import { SITE, absoluteUrl } from '../data/seoData';

/**
 * SEO component - maakt gebruik van React 19 native metadata hoisting.
 * Rendert <title>, <meta>, <link rel="canonical"> en JSON-LD schema.
 */
export const SEO = ({
  title,
  description,
  path = '',
  image,
  type = 'website',
  jsonLd = [],
  noindex = false,
}) => {
  const url = absoluteUrl(path);
  const img = image || SITE.ogImage;
  const fullTitle = title.includes('Nexon') ? title : `${title} | ${SITE.name}`;

  const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  // JSON-LD veilig serialiseren: escape "<" zodat een </script>-breakout
  // (en daarmee XSS) onmogelijk is, ook bij onverwachte data.
  const safeSchemas = useMemo(
    () => schemas.filter(Boolean).map((s) => JSON.stringify(s).replace(/</g, '\\u003c')),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [jsonLd],
  );

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content="nl_NL" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {safeSchemas.map((json, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: json }}
        />
      ))}
    </>
  );
};

export default SEO;
